import { authClient, API } from "../../utils/index";

export const getPromoFaqsAdmin = () => {
	return authClient().get(`${API}/promo-faq?all=1`);
};

export const getPromoFaqById = (id) => {
	return authClient().get(`${API}/promo-faq/${id}`);
};

export const postPromoFaq = (body) => {
	return authClient().post(`${API}/promo-faq`, body);
};

export const putPromoFaq = (id, body) => {
	return authClient().put(`${API}/promo-faq/${id}`, body);
};

export const movePromoFaq = (id, direction) => {
	return authClient().post(`${API}/promo-faq/${id}/move`, { direction });
};

export const deletePromoFaq = (id) => {
	return authClient().delete(`${API}/promo-faq/${id}`);
};
